import { forwardRef, useMergeRefs } from '@chakra-ui/react';
import { useMemo } from 'react';
import useMeasure from 'react-use-measure';

import { Box, type BoxProps } from '@frontend/components';

import { ScrollContainerContext } from '../context';

export type ScrollContainerProps = BoxProps & {
  tableIsEmpty: boolean;
};

export const ScrollContainer = forwardRef<ScrollContainerProps, 'div'>(
  ({ tableIsEmpty, children }, forwardedRef) => {
    const [scrollContainerRef, scrollContainerBounds] = useMeasure();

    const mergedRefs = useMergeRefs(forwardedRef, scrollContainerRef);

    const { width: scrollContainerWidth } = scrollContainerBounds;

    const scrollContainerContextValue = useMemo(
      () => ({ scrollContainerWidth }),
      [scrollContainerWidth],
    );

    return (
      <Box
        ref={mergedRefs}
        className="overflow-container"
        flex="1 1 100%"
        overscrollBehavior="contain"
        overflow={tableIsEmpty ? 'hidden' : 'auto'}
        backgroundColor="page.background"
      >
        <ScrollContainerContext.Provider value={scrollContainerContextValue}>
          {children}
        </ScrollContainerContext.Provider>
      </Box>
    );
  },
);
